import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from '../components/CheckoutForm';

const stripePromise = loadStripe('pk_live_51SU2VBD0EPeXZoBvYcbgEmWCEqb6nkam5lxQWicV6d8QsgPf6wkwtUrhev5SMeaMoyauOnqy8oS6x7Ks245cqLNG008cFxv4OQ'); // Replace with your Stripe publishable key

const PaymentPage = () => {
  return (
    <div>
      <h2>Payment Page</h2>
      <Elements stripe={stripePromise}>
        <CheckoutForm amount={1000} /> {/* Amount in cents */}
      </Elements>
    </div>
  );
};

export default PaymentPage;